import React, { useEffect, useRef } from "react";
import { Frame, Element } from "@craftjs/core";
import { Container } from "../user/Container";
import { HeaderSection } from "../sections/HeaderSection";
import { HeroSection } from "../sections/HeroSection";
import { WhyChooseUs } from "../sections/WhyChooseUs";
import { TestimonialsSection } from "../sections/TestimonialsSection";
import { CTASection } from "../sections/CTASection";
import { FooterSection } from "../sections/FooterSection";
import { DeviceBreakpoint } from "../../App";
import "../../styles/components/layout/CanvasArea.css";

interface CanvasAreaProps {
  canvasSize: DeviceBreakpoint;
}

export const CanvasArea: React.FC<CanvasAreaProps> = ({ canvasSize }) => {
  const canvasRef = useRef<HTMLDivElement>(null);

  // Use effect to update the canvas width
  useEffect(() => {
    if (canvasRef.current) {
      canvasRef.current.style.width = `${canvasSize.width}px`;
      canvasRef.current.style.maxWidth = `${canvasSize.width}px`;
    }
  }, [canvasSize]);

  return (
    <div className="canvas-container-wrapper">
      <div
        ref={canvasRef}
        className="canvas-container"
        style={{
          width: `${canvasSize.width}px`,
          maxWidth: `${canvasSize.width}px`,
        }}
      >
        {/* Clear device label above the canvas */}
        <div className="device-label">
          {canvasSize.icon} {canvasSize.name} - {canvasSize.width}px
        </div>

        {/* Wrap Frame in div with 100% width */}
        <div className="canvas-frame-wrapper">
          <Frame>
            <Element
              canvas
              is={Container}
              width="100%"
              height="auto"
              padding="0"
              background="#ffffff"
              margin="0"
              borderRadius={0}
              flexDirection="column"
              alignItems="center"
              justifyContent="flex-start"
            >
              <HeaderSection />
              <HeroSection />
              <WhyChooseUs />
              <TestimonialsSection />
              <CTASection />
              <FooterSection />
            </Element>
          </Frame>
        </div>
      </div>
    </div>
  );
};
